import GLightbox from 'glightbox';

export default function lightbox() {

  const lightbox = GLightbox({
    touchNavigation: true,
    loop: true,
    selector: ".wp-block-gallery a"
  });
}